declare global {
  interface HTMLElement {
    _enterHandler?: (e: KeyboardEvent) => void
  }
}

export const enterClick = {
  mounted(el: HTMLElement) {
    const handler = (e: KeyboardEvent) => {
      // Ignore if the event target is an input, textarea, or contenteditable element
      const target = e.target as HTMLElement
      if ( 
        target.tagName === 'TEXTAREA' ||
        target.getAttribute('contenteditable') === 'true' ||
        target.closest('.p-calendar') // Ignore PrimeVue calendar inputs
      ) {
        return
      }

      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault()
        el.click()
      }
    }
    
    // Add event listener to document
    document.addEventListener('keydown', handler)
    
    // Store handler for cleanup
    el._enterHandler = handler
  },
  
  unmounted(el: HTMLElement) {
    // Cleanup event listener
    if (el._enterHandler) {
      document.removeEventListener('keydown', el._enterHandler)
      delete el._enterHandler
    }
  }
}
